import { TemplateForm } from '../typings'

export const EMPTY_TEMPLATE_FORM: TemplateForm = {
  name: '',
  description: '',
}
